import {
  Component,
  Input,
  OnInit,
  ViewChild,
  AfterViewInit,
  Inject,
  EventEmitter,
  Output,
} from "@angular/core";
import { Grabaciones } from "../intefaces/grabaciones.interface";
import { Recordings } from "../model/recordings";

import { CoursesService } from "../services/courses.service";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { HttpClient } from "@angular/common/http";
import { SelectionModel } from "@angular/cdk/collections";
import { Detgrabs } from "../model/detgrab";
import { DownloadService } from "../download.service";
import { Download } from "../download";
import { Observable, Subscription } from "rxjs";
import { DOCUMENT } from "@angular/common";
import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl,
} from "@angular/forms";
import { environment } from "../../environments/environment";
import { TokenService } from "../services/token";

export interface UserData {
  id: string;
  name: string;
  progress: string;
  color: string;
}

@Component({
  selector: "record-card-list",
  templateUrl: "./record-card-list.component.html",
  styleUrls: ["./record-card-list.component.css"],
})
export class RecordCardListComponent implements OnInit, AfterViewInit {
  private sessionSubscription: Subscription;
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  breakpoint: number;
  uncheckmp3: boolean;

  recordingTest: Recordings = {
    conversationId: 12345,
    ani: "",
    dnis: "",
    identificacion: "",
    fecha: "",
    fechafin: "",
    direccion: [],
    usuarios: [],
    colas: [],
    campania: [],
    contactlist: [],
  };

  allowOnlyNumbersAndPlus(event: KeyboardEvent): void {
    const allowed = /^[0-9+]$/;
    if (!allowed.test(event.key)) {
      event.preventDefault();
    }
  }
  public down_enabled: boolean = true;

  @Input()
  grabaciones: Grabaciones[];
  recordings: Recordings[];
  recordings1: Recordings[];

  cols = 1;

  curPage: number;
  pageSize: number;

  rowHeight = "500px";

  handsetPortrait = false;

  columns = [
    "id",
    "conversationId",
    "conversationStart",
    "path",
    "customerDocumentNumber",
    "customerFullName",
    "queueName",
    "namefile",
  ];
  index = [
    "id",
    "conversationId",
    "conversationStart",
    "path",
    "customerDocumentNumber",
    "customerFullName",
    "queueName",
    "namefile",
  ];
  grabs: Detgrabs[] = [];

  urlzipFile = "";

  dropdownListF = [];
  dropdownListQU = [];
  dropdownListDir = [];
  selectedItemsF = [];
  dropdownListCamp = [];
  dropdownListCL = [];
  dropdownSettingsCamp = {};
  dropdownSettingsCL = {};
  selectedItemsQU = [];
  selectedItemsDir = [];
  selectedItemsCamp = [];
  selectedItemsCL = [];
  dropdownSettingsF = {};
  dropdownSettingsDir = {};
  dropdownSettingsQU = {};
  description: string;
  firstError: string;
  isLoading = false;
  isLoadingIndeterminate = false;

  @ViewChild("multiSelect") multiSelect;
  @ViewChild("multiSelectC") multiSelectC;
  public formGroup: FormGroup;
  public selectedUsuarios = [];
  public selectedColas = [];
  public loadContent: boolean = true;
  public name = "Cricketers";
  public selectedDireccion = [];
  public selectedCamps = [];
  public selectedCL = [];
  public settingsUsers = {};
  public settingsDirs = {};
  public settingsCamps = {};
  public settingsCLs = {};
  public settingsQueues = {};
  public selectedItems3 = [];

  visible1: boolean = true;
  visibleDown: boolean = true;
  public isVisible1: boolean = false;
  daysExceeded: number | null = null;
  @Output() dateValidationMessage = new EventEmitter<string>(); // Output event
  showAlert1(): void {
    if (this.isVisible1) {
      return;
    }
    this.isVisible1 = true;
    setTimeout(() => (this.isVisible1 = false), 2500);
  }

  validationMessage: string = "";

  handleDateValidationMessage(message: string): void {
    this.validationMessage = message;
  }

  dataSource: MatTableDataSource<Detgrabs>;

  tableDataSource: MatTableDataSource<Detgrabs>;
  selectionDataSource: MatTableDataSource<Detgrabs>;
  gridCheckbox: boolean = true;
  gridMultiselect: boolean = true;
  gridPersistSelection: boolean = true;
  gridMasterSelectAllFirst: boolean = false;
  gridShowDuplicatesInClipboard: boolean = false;
  gridShowClipboard: boolean = false;
  gridMasterTogglesPageOnly: boolean = false;
  gridRowClickChangesSelection: boolean = false;
  gridHighlightLastClickedOnly: boolean = false;
  gridClickedLastNullable: boolean = false;

  download$: Observable<Download>;
  isLoading1 = false;
  isLoadingF = false;
  loading = false;

  public isVisible: boolean = false;

  showAlert(): void {
    if (this.isVisible) {
      return;
    }
    this.isVisible = true;
    setTimeout(() => (this.isVisible = false), 2500);
  }

  public isVisibleInt: boolean = false;

  showAlertInterval(): void {
    alert("The date range exceeds the limit!");
    if (this.isVisibleInt) {
      return;
    }
    this.isVisibleInt = true;
    setTimeout(() => (this.isVisibleInt = false), 2500);
  }
  list: any[];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  selection1 = new SelectionModel<Detgrabs>(true, []);
  displayedColumns: string[] = [
    "select",
    "id",
    "conversationId",
    "namefile",
    "customerFullName",
    "queueName",
  ];

  selection = new SelectionModel<Detgrabs>(true, []);
  clickedLast: Detgrabs | null = null;

  slides = {
    name: "Descargar archivo comprimido de grabaciones",
    url: this.urlzipFile,
  };

  visible: boolean = true;
  constructor(
    private rs: CoursesService,
    private http: HttpClient,
    private downloads: DownloadService,
    @Inject(DOCUMENT) private recordingsF: Recordings,
    private fb: FormBuilder,
    @Inject(DOCUMENT) private document: Document,
    private tokenS: TokenService
  ) {
    const grabs11: Detgrabs[] = [];

    this.tableDataSource = new MatTableDataSource(grabs11);
    this.tableDataSource.paginator = this.paginator;
  }
  form = this.fb.group(
    {
      conversationId: [this.recordingsF.conversationId],
      ani: [this.recordingsF.ani, [Validators.pattern(/^[0-9+]*$/)]],
      dnis: [this.recordingsF.dnis, [Validators.pattern(/^[0-9+]*$/)]],
      direccion: [this.recordingsF.direccion],
      campania: [this.recordingsF.campania],
      contactlist: [this.recordingsF.contactlist],
      cola: [this.recordingsF.colas],
      usuario: [this.recordingsF.usuarios],
      identificacion: [
        this.recordingsF.identificacion,
        [Validators.pattern(/^[0-9+]*$/)],
      ],
      fecha: [this.recordingsF.fecha],
      fechafin: [this.recordingsF.fechafin],
    },
    { validators: this.dateRangeValidator }
  );

  public setForm() {
    this.formGroup = new FormGroup({
      direccion: new FormControl(this.selectedDireccion),
      campania: new FormControl(this.selectedCamps),
      contactlist: new FormControl(this.selectedCL),
      usuarios: new FormControl(this.selectedUsuarios),
      colas: new FormControl(this.selectedColas),
      ani: new FormControl(this.recordingsF.ani),
      dnis: new FormControl(this.recordingsF.dnis),
      fecha: new FormControl(this.recordingsF.fecha, Validators.required),
      fechafin: new FormControl(this.recordingsF.fechafin),
      identificacion: new FormControl(this.recordingsF.identificacion),
    });
    this.loadContent = true;
  }

  get f() {
    return this.formGroup.controls;
  }

  public resetForm() {
    this.setForm();
    this.multiSelect.toggleSelectAll();
    this.multiSelectC.toggleSelectAll();
  }
  onDropDownCloseQueues(_item: any) { /* ... */ }
  onDropDownCloseCamps(_item: any) { /* ... */ }
  onDropDownCloseDirs(_item: any) { /* ... */ }
  onDropDownCloseCLs(_item: any) { /* ... */ }
  onDropDownCloseUsers(_item: any) { /* ... */ }
  onFilterChangeUsers(_item: any) { /* ... */ }
  onItemSelectUsers(_item: any) { /* ... */ }
  onDeSelectUsers(_item: any) { /* ... */ }
  onSelectAllUsers(_item: any) { /* ... */ }
  onDeSelectAllUsers(_item: any) { /* ... */ }
  onFilterChangeQueues(_item: any) { /* ... */ }
  onItemSelectQueues(_item: any) { /* ... */ }
  onDeSelectQueues(_item: any) { /* ... */ }
  onSelectAllQueues(_item: any) { /* ... */ }
  onDeSelectAllQueues(_item: any) { /* ... */ }
  onFilterChangeDirs(_item: any) { /* ... */ }
  onItemSelectDirs(_item: any) { /* ... */ }
  onDeSelectDirs(_item: any) { /* ... */ }
  onSelectAllDirs(_item: any) { /* ... */ }
  onDeSelectAllDirss(_item: any) { /* ... */ }
  onFilterChangeCamps(_item: any) { /* ... */ }
  onItemSelectCamps(_item: any) { /* ... */ }
  onDeSelectCamps(_item: any) { /* ... */ }
  onSelectAllCamps(_item: any) { /* ... */ }
  onDeSelectAllCamps(_item: any) { /* ... */ }
  onFilterChangeCLs(_item: any) { /* ... */ }
  onItemSelectCLs(_item: any) { /* ... */ }
  onDeSelectCLs(_item: any) { /* ... */ }
  onSelectAllCLs(_item: any) { /* ... */ }
  onDeSelectAllCLs(_item: any) { /* ... */ }
  OnItemDeSelect(_item: any) { /* ... */ }
  onSelectAll(_item: any) { /* ... */ }
  onItemSelectDir(_item: any) { /* ... */ }
  OnItemDeSelectDir(_item: any) { /* ... */ }
  onSelectAllDir(_item: any) { /* ... */ }
  onDeSelectAllDir(_item: any) { /* ... */ }
  onItemSelectCL(_item: any) { /* ... */ }
  OnItemDeSelectCL(_item: any) { /* ... */ }
  onSelectAllCL(_item: any) { /* ... */ }
  onDeSelectAllCL(_item: any) { /* ... */ }
  onItemSelectCamp(_item: any) { /* ... */ }
  OnItemDeSelectCamp(_item: any) { /* ... */ }
  onSelectAllCamp(_item: any) { /* ... */ }
  onDeSelectAllCamp(_item: any) { /* ... */ }
  onItemSelectQU(_item: any) { /* ... */ }
  OnItemDeSelectQU(_item: any) { /* ... */ }
  onSelectAllQU(_item: any) { /* ... */ }
  onDeSelectAllQU(_item: any) { /* ... */ }

  public dateRangeValidator(formGroup: FormGroup) {
    const startDate = formGroup.get("fecha")?.value;
    const endDate = formGroup.get("fechafin")?.value;
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      const diffTime = Math.abs(end.getTime() - start.getTime());
      const diffTime1 = end.getTime() - start.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays > 30) {
        this.showAlert1();
      }
      if (diffTime1 < 0) {
        this.showAlert1();
      }
      this.daysExceeded = diffDays > 30 ? diffDays - 30 : null;
      if (this.daysExceeded !== null && this.daysExceeded > 0) {
        this.dateValidationMessage.emit(
          `El rango de fecha excede el limite de ${this.daysExceeded} días.`
        );
      } else {
        this.dateValidationMessage.emit("");
      }
      return diffDays > 30 || diffTime1 < 0 ? { rangeExceeded: true } : null;
    }
    return null;
  }

  getdataUser(): void {
    let tmp = [];
    this.http.get<any>(environment.getUsers).subscribe((data) => {
      for (const item of data.message) {
        tmp.push({ item_id: item.id, item_text: item.name });
      }
      this.dropdownList = tmp;
      this.selectedUsuarios = tmp;
      let tmpDir = [];
      tmpDir.push({ item_id: "1", item_text: "Todos" });
      tmpDir.push({ item_id: "2", item_text: "Inbound" });
      tmpDir.push({ item_id: "3", item_text: "Outbound" });
      this.dropdownListDir = tmpDir;
      this.selectedDireccion = tmpDir;
    });
  }

  getdataQueues(): void {
    let tmp = [];
    this.http.get<any>(environment.getQueue).subscribe((data) => {
      for (const item of data.message) {
        tmp.push({ id: item.id, name: item.name });
      }
      this.dropdownListQU = tmp;
      this.selectedColas = tmp;
    });
  }

  getdataCamps(): void {
    let tmp = [];
    this.http.get<any>(environment.getCampaign).subscribe((data) => {
      for (const item of data.message) {
        tmp.push({ item_id: item.id, item_text: item.name });
      }
      this.dropdownListCamp = tmp;
      this.selectedCamps = tmp;
    });
  }
  getdataCLs(): void {
    let tmp = [];
    this.http.get<any>(environment.getContanctList).subscribe((data) => {
      for (const item of data.message) {
        tmp.push({ item_id: item.id, item_text: item.name });
      }
      this.dropdownListCL = tmp;
      this.selectedCL = tmp;
    });
  }

  onItemSelect(item: any) {
    this.formGroup.get("cola").setValue(item);
  }

  download() {
    this.clientdataClick();
    this.tableDataSource.data = [];
  }

  emptyList() {
    this.tableDataSource.data = [];
  }
  numberOfPages() {
    return Math.ceil(this.grabs.length / this.pageSize);
  }

  onResize(event) {
    this.breakpoint = event.target.innerWidth <= 400 ? 1 : 6;
  }

  ngOnInit() {
    this.breakpoint = window.innerWidth <= 400 ? 1 : 6;
    this.uncheckmp3 = false;
    this.dropdownSettings = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };

    this.curPage = 1;
    this.pageSize = 25;
    this.settingsUsers = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      enableCheckAll: true,
      selectAllText: "Seleccionar todo",
      unSelectAllText: "Deseleccionar todo",
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 3,
      searchPlaceholderText: "Usuarios",
      noDataAvailablePlaceholderText: "No hay datos",
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };
    this.settingsDirs = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      enableCheckAll: true,
      selectAllText: "Seleccionar todo",
      unSelectAllText: "Deseleccionar todo",
      allowSearchFilter: true,
      limitSelection: 1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 3,
      searchPlaceholderText: "Direccion",
      noDataAvailablePlaceholderText: "No hay datos",
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };
    this.settingsCamps = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      enableCheckAll: true,
      selectAllText: "Seleccionar todo",
      unSelectAllText: "Deseleccionar todo",
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 3,
      searchPlaceholderText: "Campaña",
      noDataAvailablePlaceholderText: "No hay datos",
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };
    this.settingsCLs = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      enableCheckAll: true,
      selectAllText: "Seleccionar todo",
      unSelectAllText: "Deseleccionar todo",
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 3,
      searchPlaceholderText: "ContactList",
      noDataAvailablePlaceholderText: "No hay datos",
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };
    this.settingsQueues = {
      singleSelection: false,
      idField: "id",
      textField: "name",
      enableCheckAll: true,
      selectAllText: "Seleccionar todo",
      unSelectAllText: "Deseleccionar todo",
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 3,
      searchPlaceholderText: "Colas",
      noDataAvailablePlaceholderText: "No hay datos",
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };
    this.setForm();
    this.waitForTokenAndInitData();
    this.dropdownSettings = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Seleccionar Todos",
      unSelectAllText: "Deseleccionar Todos",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
    this.dropdownSettingsQU = {
      singleSelection: false,
      idField: "id",
      textField: "name",
      selectAllText: "Selecionar Todos",
      unSelectAllText: "Deseleccionar Todos",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
    this.dropdownSettingsDir = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Seleccionar Todos",
      unSelectAllText: "Deseleccionar Todos",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
    this.dropdownSettingsCamp = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Selecionar Todos",
      unSelectAllText: "Deseleccionar Todos",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
    this.dropdownSettingsCL = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Selecionar Todos",
      unSelectAllText: "Deseleccionar Todos",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
  }
  private waitForTokenAndInitData() {
    if (this.tokenS.isTokenReady()) {
      this.loadAllData();
      return;
    }
    this.tokenS.tokenReady$.subscribe((ready) => {
      if (ready) {
        this.loadAllData();
      }
    });
  }

  private loadAllData() {
    this.getdataUser();
    this.getdataQueues();
    this.getdataCamps();
    this.getdataCLs();
  }
  save() {
    this.isLoading = true;
    this.dateRangeValidator(this.formGroup);
    this.isLoading = false;
    const props = Object.keys(this.form.value);
    this.firstError = null;
    props.forEach((prop) => {
      if (!this.firstError && this.form.get(prop).errors) {
        this.firstError = prop;
      }
    });
    if (this.firstError === "fecha") {
      this.form.get("fecha").clearValidators();
      this.form.get("fecha").updateValueAndValidity();
    }
  }

  onSubmit() {
    this.isLoading = true;
    this.dateRangeValidator(this.formGroup);
    this.getAllRecords(this.formGroup.value);
  }

  async downloadAllRecords(down: string) {
    this.isLoadingIndeterminate = true;
    this.loading = true;
    this.rs.getDownloadZIP(down).then(
      (response) => {
        this.grabs = response;
        this.urlzipFile = response;
        if (this.urlzipFile === "") {
          this.showAlert();
          this.isLoadingIndeterminate = false;
        } else {
          this.descargarZipDirecto(this.urlzipFile);
          this.isLoadingIndeterminate = false;
          if (response.statusCode === 200) {
            window.location.reload();
            this.selection.clear();
          }
        }
      },
      (_error) => {
        this.isLoadingIndeterminate = false;
      }
    );
    this.selection.clear();
  }

  getAllRecords(recc: Recordings) {
    this.isLoading = true;
    this.loading = true;
    this.rs.getRecords(recc).subscribe(
      (response) => {
        this.grabs = response;

        this.dataSource = new MatTableDataSource(this.grabs);
        this.isLoading = false;
        this.tableDataSource = new MatTableDataSource(this.grabs);
        this.selectionDataSource = new MatTableDataSource(
          this.selection.selected
        );

        this.dataSource.paginator = this.paginator;
        this.tableDataSource.paginator = this.paginator;
      },
      (error) => {
        console.log(error);
        this.isLoading = false;
        this.loading = false;
      }
    );

    this.tableDataSource.paginator = this.paginator;
    if (this.grabs.length > 0) {
      this.visibleDown = true;
    }
  }

  clientdataClick() {
    let totalSelec;
    let ress = JSON.stringify(
      {
        dataMp3: this.uncheckmp3,
        data: this.gridMultiselect
          ? this.selection.selected
          : this.selection.selected[0],
        clickedLast: this.clickedLast,
      },
      (key, value) => {
        if (key === "selected") {
          return value;
        }
        return value;
      },
      2
    );

    switch (this.uncheckmp3) {
      case true:
        if (this.selection.selected.length <= environment.maxMP3 + 1) {
          this.downloadAllRecords(ress);
          this.uncheckmp3 = false;
        } else {
          alert(
            "No se puede descargar más de " +
              environment.maxMP3 +
              " archivos .MP3"
          );
          this.uncheckmp3 = false;
        }
        break;
      case false:
        totalSelec = this.selection.selected.length;
        if (totalSelec <= environment.maxOpus + 1) {
          this.downloadAllRecords(ress);
          this.uncheckmp3 = false;
          this.selection.clear();
        } else {
          alert(
            "No se puede descargar más de: " +
              environment.maxOpus +
              " archivos .opus "
          );
          this.uncheckmp3 = false;
          this.selection.clear();
        }
        break;

      default:
        this.uncheckmp3 = false;
    }
  }

  public downloadNew(downloadUrl: string): void {
    window.open(downloadUrl, "_blank");
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  rowCompare(row1: Detgrabs, row2: Detgrabs) {
    const state = row1.message;
    const id1 = (state as any)?.id;
    const state2 = row2.message;
    const id2 = (state2 as any)?.id;

    return id1 === id2;
  }

  ngAfterViewInit() {
    this.tableDataSource.paginator = this.paginator;
  }

  page() {
    if (!this.gridPersistSelection) {
      this.selection.clear();
      return;
    }
    if (!this.gridShowDuplicatesInClipboard) {
      this.tableDataSource.data = [
        ...this.tableDataSource.data.map((d) => ({ ...d })),
      ];
      const currentPageData = this.tableDataSource._pageData(
        this.tableDataSource.data
      );
      const selectedNotInPage = this.selection.selected.filter(
        (s) => !currentPageData.find((c) => this.rowCompare(c, s))
      );
      this.selectionDataSource.data = selectedNotInPage;
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.tableDataSource.filter = filterValue.trim().toLowerCase();

    if (this.tableDataSource.paginator) {
      this.tableDataSource.paginator.firstPage();
    }
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => this.selection.select(row));
  }

  get selected() {
    return JSON.stringify(this.selection.selected);
  }
  ngOnDestroy() {
    // Cancelar suscripción para evitar memory leaks
    if (this.sessionSubscription) {
      this.sessionSubscription.unsubscribe();
    }
  }

  public descargarZipDirecto(url: string): void {
    if (!url) {
      this.showAlert();
      return;
    }
    const link = document.createElement('a');
    link.href = url;
    link.download = 'grabaciones.zip';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

}
